import {
  ListItem,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  UnorderedList,
  useDisclosure,
} from '@chakra-ui/react';
import {
  PARTNER_TAG_LINKS,
  TAGS,
} from '@web-app/components/PatientTags/constants';
import { SessionReminderModal } from '@web-app/components/SessionReminderModal';
import { Button } from '@web-app/components/ui/Button/button';
import { useLingoEnabled } from '@web-app/utils/feature-flags/lingo';
import React, { useEffect, useRef } from 'react';

const LingoReminderModal: React.FC = () => {
  const isLingoEnabled = useLingoEnabled();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialFocusRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (isLingoEnabled) {
      onOpen();
    }
  }, [isLingoEnabled, onOpen]);

  if (!isLingoEnabled) {
    return null;
  }

  return (
    <SessionReminderModal
      popupId="lingo-patient-reminders"
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      initialFocusRef={initialFocusRef}
    >
      <ModalOverlay />
      <ModalContent
        ref={initialFocusRef as React.Ref<HTMLElement>}
        tabIndex={-1}
        sx={{ outline: 'none' }}
        bg="bg.default"
        color="text.default"
      >
        <ModalHeader>Lingo Patient Reminders</ModalHeader>

        <ModalBody>
          <UnorderedList spacing={3} pl={2}>
            <ListItem>
              <strong>What is Lingo?</strong>
              &nbsp;Lingo from Abbott is a continuous glucose monitor (CGM) that
              helps patients see how food, activity, sleep, and other lifestyle
              factors affect their glucose
            </ListItem>
            <ListItem>
              <strong>What this means for you?</strong>
              &nbsp;Use your patient&apos;s Lingo data to help inform
              conversations about nutrition, lifestyle, and glucose trends.
            </ListItem>
            <ListItem>
              Partnerships are vital to the Berry Street ecosystem — revisit{' '}
              Lingo resources{' '}
              <a
                href={PARTNER_TAG_LINKS[TAGS.LINGO.toLowerCase()]}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-legacy underline"
              >
                here
              </a>
              .
            </ListItem>
          </UnorderedList>
        </ModalBody>

        <ModalFooter>
          <div className="flex w-full flex-col gap-2">
            <Button
              onClick={onClose}
              className="w-full bg-primary-legacy text-primary-foreground hover:bg-primary-legacy/90"
            >
              Got it!
            </Button>
          </div>
        </ModalFooter>
      </ModalContent>
    </SessionReminderModal>
  );
};

export default LingoReminderModal;
